import React from "react";
import { Grid, Typography, Box } from "@material-ui/core";

export default function Terminos(props) {
  const { classes } = props;
  return (
    <Grid item xs={12} style={{ textAlign: "center" }}>
      <hr></hr>
      <Box display="flex" alignItems="center" justifycontent="center">
        <Box p={1} className={`${classes.colorBlock} ${classes.orange}`}></Box>
        <Box p={1}>
          <Typography variant="h5" color="textPrimary">
            Terminadas
          </Typography>
        </Box>
        <Box p={1} className={`${classes.colorBlock} ${classes.green}`}></Box>
        <Box p={1}>
          <Typography variant="h5" color="textPrimary">
            Hoy
          </Typography>
        </Box>
        <Box p={1} className={`${classes.colorBlock} ${classes.red}`}></Box>
        <Box p={1}>
          <Typography variant="h5" color="textPrimary">
            Próximas
          </Typography>
        </Box>
      </Box>
      <hr></hr>
    </Grid>
  );
}
